import { Controller } from "@hotwired/stimulus"

// Toggles all row checkboxes from a single header "select all" checkbox.
//
//   data-controller="admin-bulk-select"
//   <input type="checkbox" data-admin-bulk-select-target="all"
//          data-action="change->admin-bulk-select#toggleAll">
//   <input type="checkbox" data-admin-bulk-select-target="item">
export default class extends Controller {
  static targets = ["all", "item"]

  toggleAll() {
    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = this.allTarget.checked
    })
  }
}
